import * as React from 'react';
import Box from '@mui/material/Box';
import { FileMetadata } from "../types";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { DigitalStylingThumbnail } from "./DigitalStylingThumbnail";

export type UploadsInProgressLabels = {
	heading: string;
};

type UploadsInProgressProps = {
	labels: UploadsInProgressLabels;
	files: FileMetadata[];
};


export function UploadsInProgress({ files, labels }: UploadsInProgressProps) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant="h4">{labels.heading}</Typography>
        <List sx={{ width: '30%' }}>
          {files.map((file) => (
            <ListItem key={file.photoUploadMetadataId}>
              <ListItemText primary={file.filename} />
            </ListItem>
          ))}
        </List>
      </Box>
    )
}
